import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { GuestRating as GuestRating$2, RatingContainer, Grade, Label } from './GuestRating.style.js';
import texts from './GuestRating.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import Icon from '../Icon/Icon.js';
import { ICON_COMMS_REVIEW } from '../../icons/ICON_COMMS_REVIEW.js';

var _excluded = ["rating", "onClick", "showLabel", "showScale", "customLabel", "dontShowDecimal", "inlineLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GuestRating = function GuestRating(_ref) {
  var rating = _ref.rating,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
    _ref$showScale = _ref.showScale,
    showScale = _ref$showScale === void 0 ? false : _ref$showScale,
    _ref$customLabel = _ref.customLabel,
    customLabel = _ref$customLabel === void 0 ? null : _ref$customLabel,
    _ref$dontShowDecimal = _ref.dontShowDecimal,
    dontShowDecimal = _ref$dontShowDecimal === void 0 ? false : _ref$dontShowDecimal,
    _ref$inlineLabel = _ref.inlineLabel,
    inlineLabel = _ref$inlineLabel === void 0 ? false : _ref$inlineLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  if (typeof rating !== 'number' || rating < 1) {
    return false;
  }
  var displayRating = (Math.round(rating * 10) / 10).toString().replace('.', ',');
  if (displayRating.indexOf(',') < 0 && !dontShowDecimal) {
    displayRating += ',0';
  }
  var renderType = onClick ? 'button' : 'div';
  var guestRatingProps = _objectSpread({
    onClick: onClick,
    type: onClick ? 'button' : null,
    as: renderType,
    $hasOnclick: !!onClick,
    $inlineLabel: inlineLabel
  }, rest);
  return /*#__PURE__*/jsxs(GuestRating$2, _objectSpread(_objectSpread({}, guestRatingProps), {}, {
    title: texts.guestRating,
    children: [/*#__PURE__*/jsxs(RatingContainer, {
      children: [/*#__PURE__*/jsx(Icon, {
        "aria-hidden": "true",
        path: ICON_COMMS_REVIEW,
        size: "xs"
      }), /*#__PURE__*/jsxs(Grade, {
        children: [displayRating, showScale && /*#__PURE__*/jsx("span", {
          children: "/5"
        })]
      })]
    }), (showLabel || customLabel) && /*#__PURE__*/jsx(Label, {
      "aria-hidden": "true",
      children: customLabel || texts[culture].guestRatingShort
    }), /*#__PURE__*/jsx("span", {
      className: "visually-hidden",
      children: "".concat(texts[culture].guestRating, ": ").concat(rating, "/5")
    })]
  }));
};
var GuestRating$1 = GuestRating;

export { GuestRating$1 as default };
//# sourceMappingURL=GuestRating.js.map
